import React from 'react';

import { Stack } from '@mui/material';
import { useLocation } from 'react-router-dom';

import { useCustomAuth } from 'auth/AuthContext';

type Props = {
    children?: React.ReactNode;
    id?: string;
};

const Background = ({ children, id }: Props) => {
    const path = useLocation().pathname.substring(useLocation().pathname.indexOf('/') + 1);
    const { isAuthenticated } = useCustomAuth();

    // tabIndex={-1} when an id is set so the skip-link target can programmatically receive focus.
    const focusTargetProps = id ? { tabIndex: -1, sx: { outline: 'none' } } : {};

    if (path === '' && isAuthenticated) {
        return (
            <Stack id={id} {...focusTargetProps}>
                {children}
            </Stack>
        );
    }
    return (
        <Stack id={id} maxWidth="128rem" width="100%" {...focusTargetProps}>
            {children}
        </Stack>
    );
};

export default Background;
